import { connect } from "react-redux";
import Cards from "../../components/card/Cards";
import {
  getCards,
  goToUrl,
  getPin,
  requestExpressToken,
} from "../../actions/services";
import {
  selectCard,
  setError,
  populateCards,
  setPin,
  setStage,
  logout,
  setLoader,
  callGoogleAnalytics,
  setFocus,
  Stages,
} from "../../actions/actions";
import { exception } from "react-ga";
import { Disposable } from "rx";

var customError = "";
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFocus: (refName) => {
      dispatch(setFocus(refName));
    },
    onSelectCard: (last4Digits) => {
      dispatch(selectCard(last4Digits));
    },
    onGetCards: () => {
      getCards()
        .then((cardsResponse) => {
          dispatch(setError(null));

          if (
            cardsResponse.data.statusCode != 1 &&
            cardsResponse.data.statusCode != -1
          ) {
            customError = cardsResponse;
            throw new Error(cardsResponse);
          }

          //  dispatch(populateCards(cardsResponse.data));
          // dispatch(selectCard(cardsResponse.data[0].last4Digits));
          if (
            cardsResponse.data.result != null &&
            cardsResponse.data.result.cards != undefined
          ) {
            dispatch(populateCards(cardsResponse.data.result.cards));
            dispatch(
              selectCard(cardsResponse.data.result.cards[0].last4Digits)
            );
          }
        })
        .catch((error) => {
          if (customError != "") {
            error.response = customError;
            let text;
            let status;
            if (error.response.data.statusDescription != null)
              text = error.response.data.statusDescription;
            if (error.response.data.statusCode != 1)
              status = error.response.data.statusCode;

            dispatch(setError(status, text));
          } else {
            dispatch(setError(error.response.status, error.response.data));
          }
          dispatch(setLoader(false));
          dispatch(
            callGoogleAnalytics(
              window.settings.ga.pages.cardsError,
              error.response.data
            )
          );
        })
        .then(() => {
          dispatch(setStage(Stages.cards));
          dispatch(setLoader(false));
        });
    },
    onGetPin: (requestedLast4Digits) => {
      var customError = "";
      dispatch(setLoader(true));
      getPin(requestedLast4Digits)
        .then((response) => {
          if (response.data.statusCode != 1) {
            customError = response;
            throw new Error(response);
          }
          dispatch(callGoogleAnalytics(window.settings.ga.pages.privacyOK));
          dispatch(setError(null));
          dispatch(setPin(response.data.result.pinNum));
          dispatch(setStage(Stages.pin));
          dispatch(setLoader(false));
          dispatch(selectCard(requestedLast4Digits));
        })
        .catch((error) => {
          if (customError != "") {
            error.response = customError;
            let text = "אירעה שגיאה";
            let status = error.response.status;
            if (error.response.data.statusDescription != null)
              text = error.response.data.statusDescription;
            if (error.response.data.statusCode != 1)
              status = error.response.data.statusCode;

            //dispatch(setMessage(status, text,true));
            dispatch(setError(status, text));
          } else {
            dispatch(setError(error.response.status, error.response.data));
          }
          dispatch(
            callGoogleAnalytics(
              window.settings.ga.pages.privacyError,
              error.response.data
            )
          );
        })
        .then(() => {
          dispatch(setLoader(false));
        });
    },
    onExpressToken: (requestedLast4Digits) => {
      dispatch(setLoader(true));
      requestExpressToken(requestedLast4Digits)
        .then((response) => {
          dispatch(setError(null));
          goToUrl(window.settings.offlineTokenUrl + "?sid=" + response.data);
        })
        .catch((error) => {
          dispatch(
            callGoogleAnalytics(
              window.settings.ga.pages.cardsError,
              error.response.data
            )
          );
          dispatch(setError(error.response.status, error.response.data));
        })
        .then(() => {
          dispatch(setLoader(false));
        });
    },
    onShowPrivacy: () => {
      dispatch(callGoogleAnalytics(window.settings.ga.pages.cardsGetPin));
      dispatch(setError(200, ""));
    },
    onClosePrivacy: () => {
      dispatch(callGoogleAnalytics(window.settings.ga.pages.privacyCancel));
      dispatch(setError(null));
    },
    onCloseMessage: () => {
      //  goToUrl(window.settings.provider.homeSiteUrl);
      dispatch(setError(null));
      //   dispatch(setStage(Stages.sendOtp));
      dispatch(setStage(Stages.login));
    },
    onCallGa: (page, error) => {
      dispatch(callGoogleAnalytics(page, error));
    },
    onLogout: () => {
      //   dispatch(logout(Stages.sendOtp));
      dispatch(logout(Stages.login));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    cards: state.session.card.cards,
    requestedLast4Digits: state.session.card.requestedLast4Digits,
    error: state.session.app.error,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cards);



// WEBPACK FOOTER //
// ./src/containers/card/Cards.js